import { styled } from '@linaria/react';
import { colors, fonts } from '../../theme/tokens';

export const JourneyPickerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media screen and (max-width: 600px) {
    width: 100%;
    width: min(300px, 100%);
  }
`;

export const ChevronIcon = styled.span`
  display: flex;
  align-items: center;
  color: ${colors.fontSecondary};
  transition: transform 0.15s ease;
`;

export const CategoryOption = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: ${({ $active }) => ($active ? colors.lighterGrey : 'none')};
  border: none;
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${({ $active }) => ($active ? fonts.weight.semiBold : fonts.weight.normal)};
  color: ${colors.fontPrimary};
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.lighterGrey};
  }
`;
